import { PrimeIcons } from "primereact/api";
var getButtonModes = function (t) { return ({
    SaveWithIconBadge: {
        category: "icon_with_badge",
        imageOrIcon: PrimeIcons.SAVE,
        badgeType: "info",
        badgeText: t("com.beo.dakz.button.save"),
        route: "",
        key: "",
    },
    SendWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.SEND,
        label: t("com.beo.dakz.button.send"),
    },
    UserEditWithIcon: {
        category: "icon_with_badge",
        imageOrIcon: PrimeIcons.USER_EDIT,
        badgeType: "info",
        badgeText: t("com.beo.dakz.button.edit"),
        route: "",
        key: "",
    },
    ListingPageWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.LIST,
        label: t("com.beo.dakz.button.list"),
    },
    SaveWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.SAVE,
        label: t("com.beo.dakz.button.save"),
    },
    RefreshWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.REFRESH,
        label: t("com.beo.dakz.button.refresh"),
    },
    AddWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.PLUS,
        label: t("com.beo.dakz.button.add"),
    },
    DeleteWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.TRASH,
        label: t("com.beo.dakz.button.delete"),
    },
    SubmitWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.CHECK,
        label: t("com.beo.dakz.button.submit"),
    },
    PrintWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.PRINT,
        label: t("com.beo.dakz.button.print"),
    },
    ClearWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: "pi pi-eraser",
        label: t("com.beo.dakz.button.clear"),
    },
    CancelWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: "pi pi-times",
        label: t("com.beo.dakz.button.cancel"),
    },
    ClearFilter: {
        category: "icon_without_badge",
        imageOrIcon: "pi pi-filter-slash",
        label: t("com.beo.dakz.button.clear"),
    },
    EditWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.PENCIL,
        label: t("com.beo.dakz.button.edit"),
    },
    UpdateWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.PENCIL,
        label: t("com.beo.dakz.button.update"),
    },
    UploadWithIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.UPLOAD,
        label: t("com.beo.dakz.button.upload"),
    },
    UploadWithIconTab: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.UPLOAD,
        label: t("com.beo.dakz.button.upload"),
    },
    SearchIcon: {
        category: "icon_without_badge",
        imageOrIcon: PrimeIcons.SEARCH,
        label: t("com.beo.dakz.button.search"),
    },
}); };
export default getButtonModes;
